import { render } from "./HeaderImageTitle.component.vue?vue&type=template&id=0a359422"
import script from "./HeaderImageTitle.component.vue?vue&type=script&lang=js"
export * from "./HeaderImageTitle.component.vue?vue&type=script&lang=js"

import "./HeaderImageTitle.component.vue?vue&type=style&index=0&id=0a359422&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__